import { render, staticRenderFns } from "./SetNews.vue?vue&type=template&id=41f83076&"
import script from "./SetNews.vue?vue&type=script&lang=js&"
export * from "./SetNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports